"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.arrow_direction = exports.ring_colors_as_choice_list = void 0;
function ring_colors_as_choice_list() {
    return [
        { color: default_ring_color, display_name: 'Default Ring Color', value: default_ring_color },
        {
            color: default_contrast_ring_color,
            display_name: 'Default Contrast Ring Color',
            value: default_contrast_ring_color
        },
        {
            color: non_standard_evaluation_ring_color,
            display_name: 'Non-Standard Evaluation Ring Color',
            value: non_standard_evaluation_ring_color
        },
        {
            color: non_standard_evaluation_contrast_ring_color,
            display_name: 'Non-Standard Evaluation Contrast Ring Color',
            value: non_standard_evaluation_contrast_ring_color
        },
    ];
}
exports.ring_colors_as_choice_list = ring_colors_as_choice_list;
function arrow_direction(direction) {
    if (direction == 10) {
        return "rotate(45deg)";
    }
    if (direction == 20) {
        return "rotate(315deg)";
    }
    if (direction == 30) {
        return "rotate(135deg)";
    }
    if (direction == 40) {
        return "rotate(225deg)";
    }
}
exports.arrow_direction = arrow_direction;
